import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, path, type = 'website', article = null, faq = null, breadcrumbs = null }) {
  const baseUrl = 'https://forsyt.com';
  const fullUrl = `${baseUrl}${path || ''}`;
  const siteName = 'Forsyt';
  const defaultImage = `${baseUrl}/assets/x0wuorg2.png`;

  return (
    <Helmet>
      <title>{`${title} | ${siteName}`}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={defaultImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {article && (
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            datePublished: article.datePublished,
            author: { '@type': 'Organization', name: 'Forsyt' },
            publisher: { '@type': 'Organization', name: 'Forsyt', logo: { '@type': 'ImageObject', url: defaultImage } },
            mainEntityOfPage: { '@type': 'WebPage', '@id': fullUrl },
          })}
        </script>
      )}

      {faq && faq.length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faq.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: { '@type': 'Answer', text: item.answer },
            })),
          })}
        </script>
      )}

      {breadcrumbs && breadcrumbs.length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbs.map((crumb, i) => ({
              '@type': 'ListItem',
              position: i + 1,
              name: crumb.name,
              item: `${baseUrl}${crumb.path}`,
            })),
          })}
        </script>
      )}
    </Helmet>
  );
}
